import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=b99b2d3c&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=ts"
export * from "./orderDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99b2d3c",
  null
  
)

export default component.exports